"use client";
import Image from "next/image";
import { getStrapiMedia } from "../utils/api-helpers";

interface ThreeImageBlockProps {
  data: {
    item: any[];
  };
}

export default function ThreeImageBlock({data}: ThreeImageBlockProps) {
  const pics = data.item.map((image: any) => ({
    img: { url: getStrapiMedia(image.img.data[0].attributes.url) },
    text: image.text,
  }));

  return (
    <div className="px-[3.5rem] dt:px-[8rem] w-full dt:w-2/3 mx-auto mt-1 dt:mt-2 text-center mb-[9rem] dt:mb-[11rem]">
      <div className="grid grid-cols-2 gap-1 dt:gap-2">
        {pics.map((pic, index) => (
          <div
            key={index}
            className={`w-full relative rounded-1/2 overflow-hidden text-white h-[10rem] dt:h-[28rem] ${index === 0 ? "col-span-2" : ""}`}
          >
            <Image
              src={pic.img.url || "/placeholder.png"}
              alt={pic.text}
              fill
              className="object-cover z-[1]"
              sizes="(max-width: 768px) 100vw, 66vw"
              quality={75}
            />
            <label className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 uppercase font-bold tracking-wider font-breit text-3/4 dt:text-1.5 leading-3/4 dt:leading-1.5 z-[2]">
              {pic.text}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}
